// @ts-nocheck
import Breadcrumbs from "@insite/mobius/Breadcrumbs";
import { LinkProps } from "@insite/mobius/Link";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import { StyleguideSection } from "@store/Library/Components/Toolkit/Styleguide/ui";
import React, { FC, useState } from "react";
import { css } from "styled-components";

const links: LinkProps[] = [
    { children: "Home", href: "#" },
    { children: "Category", href: "#" },
    { children: "SubCategory", href: "#" },
    { children: "Current Page", href: "#" },
];

const breadcrumbsCss = css`
    padding: 0 !important;
    ${x => x.theme.breadcrumbs.defaultProps?.css}
`;

const StyleguideBreadcrumbs: FC = () => {
    const [sectionId] = useState(`section-${uniqueId()}`);

    return (
        <StyleguideSection title="Breadcrumbs" sectionId={sectionId}>
            <Breadcrumbs links={links} css={breadcrumbsCss} />
        </StyleguideSection>
    );
};

export default StyleguideBreadcrumbs;
